import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.SizeDescriptionSmall1,
  LocationVarKey.SizeDescriptionSmall2,
  LocationVarKey.SizeDescriptionMedium1,
  LocationVarKey.SizeDescriptionMedium2,
  LocationVarKey.SizeDescriptionLarge1,
  LocationVarKey.SizeDescriptionLarge2,
  LocationVarKey.SizeDescriptionExtraLarge1,
  LocationVarKey.SizeDescriptionExtraLarge2,
  LocationVarKey.SizeDescription1Bedroom1,
  LocationVarKey.SizeDescription1Bedroom2,
  LocationVarKey.SizeDescription2Bedroom1,
  LocationVarKey.SizeDescription2Bedroom2,
  LocationVarKey.SizeDescription3Bedroom1,
  LocationVarKey.SizeDescription3Bedroom2,
  LocationVarKey.SizeDescription45Bedroom1,
  LocationVarKey.SizeDescription45Bedroom2,
  LocationVarKey.SizeDescription5x51,
  LocationVarKey.SizeDescription5x52,
  LocationVarKey.SizeDescription5x101,
  LocationVarKey.SizeDescription5x102,
  LocationVarKey.SizeDescription10x101,
  LocationVarKey.SizeDescription10x102,
  LocationVarKey.SizeDescription10x151,
  LocationVarKey.SizeDescription10x152,
  LocationVarKey.SizeDescription10x201,
  LocationVarKey.SizeDescription10x202,
  LocationVarKey.SizeDescription10x301,
  LocationVarKey.SizeDescription10x302,
  LocationVarKey.SizeDescriptionSmallVehicle1,
  LocationVarKey.SizeDescriptionSmallVehicle2,
  LocationVarKey.SizeDescriptionMotorcycle1,
  LocationVarKey.SizeDescriptionMotorcycle2,
  LocationVarKey.SizeDescriptionSedan1,
  LocationVarKey.SizeDescriptionSedan2,
  LocationVarKey.SizeDescriptionTruck1,
  LocationVarKey.SizeDescriptionTruck2,
  LocationVarKey.SizeDescriptionRV1,
  LocationVarKey.SizeDescriptionRV2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Size Descriptions
      </PageHeader>

      <SectionHeader {...page}> Small </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionSmall1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionSmall2}
        enableSwitchVar={LocationVarKey.SizeDescriptionSmall2Enabled}
      />

      <SectionHeader {...page}> Medium </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionMedium1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionMedium2}
        enableSwitchVar={LocationVarKey.SizeDescriptionMedium2Enabled}
      />

      <SectionHeader {...page}> Large </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionLarge1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionLarge2}
        enableSwitchVar={LocationVarKey.SizeDescriptionLarge2Enabled}
      />

      <SectionHeader {...page}> Extra Large </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionExtraLarge1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionExtraLarge2}
        enableSwitchVar={LocationVarKey.SizeDescriptionExtraLarge2Enabled}
      />

      <SectionHeader {...page}> 1 Bedroom </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription1Bedroom1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription1Bedroom2}
        enableSwitchVar={LocationVarKey.SizeDescription1Bedroom2Enabled}
      />

      <SectionHeader {...page}> 2 Bedrooms </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription2Bedroom1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription2Bedroom2}
        enableSwitchVar={LocationVarKey.SizeDescription2Bedroom2Enabled}
      />

      <SectionHeader {...page}> 3 Bedrooms </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription3Bedroom1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription3Bedroom2}
        enableSwitchVar={LocationVarKey.SizeDescription3Bedroom2Enabled}
      />

      <SectionHeader {...page}> 4-5 Bedrooms </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription45Bedroom1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription45Bedroom2}
        enableSwitchVar={LocationVarKey.SizeDescription45Bedroom2Enabled}
      />

      <SectionHeader {...page}> 5x5 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription5x51} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription5x52}
        enableSwitchVar={LocationVarKey.SizeDescription5x52Enabled}
      />

      <SectionHeader {...page}> 5x10 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription5x101} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription5x102}
        enableSwitchVar={LocationVarKey.SizeDescription5x102Enabled}
      />

      <SectionHeader {...page}> 10x10 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription10x101} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription10x102}
        enableSwitchVar={LocationVarKey.SizeDescription10x102Enabled}
      />

      <SectionHeader {...page}> 10x15 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription10x151} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription10x152}
        enableSwitchVar={LocationVarKey.SizeDescription10x152Enabled}
      />

      <SectionHeader {...page}> 10x20 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription10x201} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription10x202}
        enableSwitchVar={LocationVarKey.SizeDescription10x202Enabled}
      />

      <SectionHeader {...page}> 10x30 </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescription10x301} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescription10x302}
        enableSwitchVar={LocationVarKey.SizeDescription10x302Enabled}
      />

      <SectionHeader {...page}> Small Vehicle </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionSmallVehicle1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionSmallVehicle2}
        enableSwitchVar={LocationVarKey.SizeDescriptionSmallVehicle2Enabled}
      />

      <SectionHeader {...page}> Motorcycle </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionMotorcycle1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionMotorcycle2}
        enableSwitchVar={LocationVarKey.SizeDescriptionMotorcycle2Enabled}
      />

      <SectionHeader {...page}> Sedan </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionSedan1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionSedan2}
        enableSwitchVar={LocationVarKey.SizeDescriptionSedan2Enabled}
      />

      <SectionHeader {...page}> Truck </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionTruck1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionTruck2}
        enableSwitchVar={LocationVarKey.SizeDescriptionTruck2Enabled}
      />

      <SectionHeader {...page}> RV </SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.SizeDescriptionRV1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.SizeDescriptionRV2}
        enableSwitchVar={LocationVarKey.SizeDescriptionRV2Enabled}
      />
    </>
  );
}
